<template>
  <!-- 日期选择器类型
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="显示类型"> 
      <el-select class="setting-date-type" v-model="dateType">
        <el-option value="year" label="年历"></el-option>
        <el-option value="month" label="月历"></el-option>
        <el-option value="date" label="日历"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 显示类型
     *  @description 将 dateType 字段映射到当前 dateType 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      dateType: { 
        parent: i => i.baseOption,
        attr: "dateType" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingDateType.vue